import { FC } from "preact/compat";
import GridIcon from "~/assets/calendar-grid.svg";

const Preview: FC = () => (
    <div className="flex size-full items-center justify-center">
        <GridIcon width="120" height="80" />
    </div>
);

export default Preview;
